import React, { useState, useEffect, useCallback } from "react"
import { useParams } from "react-router-dom"
import { X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { CollapsiblePanel, CollectionLoader, ElementEditorWrapper, ElementLoader } from "lib/components"
import { SummaryTableEditor, SummaryTableRender } from "."
import { summary_table_data } from "./summary_table_data"

export default function SummaryTableEditingArea({ }: { }){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Elements } = queryTools.resource.parseQueryForApi("element.findAll", {})

  const [ elementsAvailable, setElementsAvailable ] = useState<any[]>([])
  const [ selectedElement, setSelectedElement ] = useState<any>(null)
  const [ showEditor, setShowEditor ] = useState<boolean>(false)

  const handleLoaderSelect = (elem:any) => {
    console.log(elem)
    setSelectedElement(elem)
  }

  useEffect(() => {
    const client_id = _Template?.AssignedTo?._id || null
    if( _Elements ) setElementsAvailable(_Elements.filter((elem:any) => elem.element_type === store.element.refstr && (elem.client_id === null || elem.client_id === client_id)))
  },[_Elements])

  return (
    <ElementEditorWrapper title="Summary Table">

      <CollapsiblePanel 
        PanelComp={() =>
          <ElementLoader 
            title="Summary Table Loader"
            clientObj={_Template?.AssignedTo}
            loaderFn={handleLoaderSelect}
            selectProp="_id"
            labelProp="name"
          />
        }
      >
        <div className="w-full relative">
          <p>There is currently {elementsAvailable.length} {store.element.title} available.</p>

          { selectedElement && (
            <div className="w-full flex flex-col gap-5">
              
              { showEditor === false ? (
                <div className="w-full flex flex-col mt-6 gap-4 bg-white p-8 flex justify-center items-center *:text-gray-900">
                  {/* <SummaryTableRender /> */}
                </div>
              ) : (
                <div className="w-full flex flex-col mt-4 px-2">
                  <SummaryTableEditor />
                </div>
              )}

              <p>To load the editor, <span className="text-yellow-500" onClick={() => setShowEditor(true)}>click here</span>.</p>
            </div>
          )}
      </div>

      </CollapsiblePanel>        
    </ElementEditorWrapper>
  )
}